<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="角色名称">
                    <c-input name="role_name" maxlength="50"></c-input>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_role_manage_edit')" prepend-icon="tf-add" @click="edit()">新增角色</c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="角色名称"
                        name="role_name"
                        width="160"
                >
                </c-table-column>

                <c-table-column
                        label="备注"
                        name="remark"
                        width="260"
                >
                    <template #default="{data}">
                        <span v-if="data.remark">{{data.remark}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建人"
                        name="create_user_realname"
                        width="110"
                >
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="160"
                ></c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="280"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_role_manage_edit')" icon="tf-edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_role_manage_auth')" icon="tf-auth" @click="$refs.roleAuthConfig.open(data, 0)">PC端权限</c-table-button>
                        <c-table-button v-if="auth('b_role_manage_auth')" icon="tf-auth" @click="$refs.roleAuthConfig.open(data, 1)">手机端权限</c-table-button>
                        <c-table-button v-if="auth('b_role_manage_delete')" icon="tf-trash" @click="remove(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <role-edit ref="roleEdit" @resolve="$refs.list.update()"></role-edit>
            <role-auth-config ref="roleAuthConfig" @resolve="$refs.list.update()"></role-auth-config>
        </module>
    </page>
</template>

<script>
import roleEdit from "@/pages/system/role_edit.vue";
import roleAuthConfig from "@/pages/system/role_auth_config.vue";

export default {
    components: {
        roleEdit,
        roleAuthConfig
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            this.$refs.list.load({
                url: '/system_role/list',
                data,
                success: () => {}
            });
        },

        edit(data) {
            this.$refs.roleEdit.open(data);
        },
        remove(data) {
            this.$confirm({
                title: '删除角色',
                message: '确定要删除该角色【'+data.role_name+'】吗？',
                resolve: () => {
                    this.request({
                        url: '/system_role/remove',
                        data: {
                            id: data.id
                        },
                        success: () => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    })
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
